var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentsPrimaryMd = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 184,
  height: 136,
  fill: "none",
  viewBox: "0 0 184 136",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 64,
  r: 64,
  fill: "var(--utility-brand-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 12,
  r: 6,
  fill: "var(--utility-brand-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 112,
  r: 8,
  fill: "var(--utility-brand-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 96,
  r: 8,
  fill: "var(--utility-brand-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 9,
  r: 5,
  fill: "var(--utility-brand-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-100, black)",
  d: "m52.937 95.314 39.878-18.595a4 4 0 0 0 1.935-5.316L71.2 20.9l-15.948-5.805L22.625 30.31a4 4 0 0 0-1.934 5.315L47.62 93.38a4 4 0 0 0 5.316 1.935"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-300, black)",
  d: "M55.252 15.095 71.2 20.9l-10.875 5.072z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-100, black)",
  d: "M72 81.724h44a4 4 0 0 0 4-4V22l-12-12H72a4 4 0 0 0-4 4v63.724a4 4 0 0 0 4 4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-300, black)",
  d: "m108 10 12 12h-12z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-100, black)",
  d: "m94.625 76.695 39.878 18.595a4 4 0 0 0 5.316-1.935l23.55-50.503-5.805-15.947-32.627-15.215a4 4 0 0 0-5.315 1.935L92.691 71.38a4 4 0 0 0 1.934 5.316"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-300, black)",
  d: "m157.564 26.905 5.805 15.947-10.876-5.071z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-400, black)",
  d: "M66 96c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M89.333 100.667 94 96m0 0 4.667 4.667M94 96v10.5m9.333-4.967a6.417 6.417 0 0 0-4.083-11.366.72.72 0 0 1-.623-.353 8.75 8.75 0 1 0-13.742 10.612"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 117.44,
  height: 126.98,
  x: -1,
  y: 10.024,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_1081",
  result: "effect2_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_1081",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: 92,
  height: 111.724,
  x: 48,
  y: 10,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_1081",
  result: "effect2_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_1081",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "c",
  width: 117.44,
  height: 126.98,
  x: 71,
  y: 10,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_1081",
  result: "effect2_dropShadow_1182_1081"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_1081",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "d",
  width: 72,
  height: 72,
  x: 58,
  y: 60,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1182_1081"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1182_1081",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentsPrimaryMd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DocumentsPrimaryMd.c2f551ed6d3025b0a676ce15ae2cd512.svg";